<template>
  <footer>
    <div class="footer-upper-section">
      <h1>Secured By EvacTracker</h1>
      <div class="logos-section">
        <img src="@/assets/images/footer/logo1.png" alt="Logan City Council">
        <img src="@/assets/images/footer/logo2.png" alt="Energy Queensland">
        <img src="@/assets/images/footer/logo3.png" alt="Electrolux">
        <img src="@/assets/images/footer/logo4.png" alt="Allied Pickfords">
        <img src="@/assets/images/footer/logo5.png" alt="QBCC">
        <img src="@/assets/images/footer/logo6.png" alt="PepsiCo">
        <img src="@/assets/images/footer/logo7.png" alt="Park Regis">
      </div>
    </div>
    <div class="footer-lower-section container">
      <div class="footer-column company-info">
        <img :src="this.appLogoImage"  alt="EvacTracker Logo" class="company-logo">
        <p>EvacTracker is a One Stop Solution – from structuring your policy and framework, to audit, consulting, training, and Evacovation technology deployment, it’s a one-window operation.</p>
      </div>
      <div class="footer-column official-info">
        <h4><b>Official info:</b></h4>
        <p><i class="fas fa-map-marker-alt"></i> Level 40, 140 William Street Melbourne, 3000 Victoria Australia</p>
        <p><i class="fas fa-envelope"></i> info@evacovation.com</p>
        <p>Open Hours: Mon - Fri: 8 am – 5 pm</p>
      </div>
      
      <div class="footer-column app-info">
        <h4><b>Get The App</b></h4>
        <img src="@/assets/images/footer/apple.png" alt="App Store">
        <img src="@/assets/images/footer/google.png" alt="App Store">
      </div>
    </div>
    <div class="footer-bottom">
      <p>2024 © All rights reserved by <span class="highlighted">EvacTracker</span></p>
    </div>
  </footer>
</template>

<script>
import { $themeConfig } from "@themeConfig";

export default {
  name: 'FooterComponent',
  created() {
    this.appName = $themeConfig.app.appName;
    this.appFullName = $themeConfig.app.appFullName;
    this.appLogoImage = $themeConfig.app.appLogoImage;
  },
};
</script>

<style scoped>
.custom-footer {
  background-color: #ffffff;
  color: #000000;
  padding: 40px 20px;
  font-family: 'Arial', sans-serif;
}

.footer-upper-section {
  background-color: #4a4a4a;
  text-align: center;
  padding: 40px 0;
}

.logos-section {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-bottom: 10px;
}

.logos-section img {
  height: 120px;
}

h1 {
  color: #ffffff;
  margin-top: 10px;
  font-size: 30px;
}

.footer-lower-section {
  display: flex;
  justify-content: space-around;
  padding: 50px;
}

.footer-column {
  flex: 1;
  padding: 0 40px;
}

.company-info p {
  max-width: 300px;
  margin-bottom: 15px;
}

.company-logo {
  height: 100px;
  margin-bottom: 10px;
}

.official-info p {
  margin-bottom: 5px;
}

.sitemap ul {
  list-style: none;
  padding: 0;
}

.sitemap ul li {
  margin-bottom: 5px;
}

.sitemap ul li a {
  color: #00af87;
  text-decoration: none;
}

.sitemap ul li a:hover {
  text-decoration: underline;
}

.app-info img {
  height: 40px;
}

.footer-bottom {
  background-color: #101010;
  color: #ffffff;
  text-align: center;
  padding: 20px 0;
}

.highlighted {
  color: #00af87;
}

.footer-column h4{
  font-size: 24px;
  padding-bottom: 20px;
}
footer {
  background-color: white;
}
</style>
